var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-header',{attrs:{"height":"64px"}},[_c('MyHeader',{attrs:{"menu-data":_vm.headerData,"menu-index":_vm.headerIndex,"main-click":_vm.mainHeaderClick,"sys-click":_vm.sysHeaderHeader,"drop-data":_vm.dropData}})],1),_c('el-main',{staticClass:"page-main"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }